import { SupportedLanguagesSymbols } from "../WidgetTab.constants";

export const SupportedLanguagesEntries = Object.entries(
  SupportedLanguagesSymbols,
) as [keyof typeof SupportedLanguagesSymbols, string][];
